module.exports = __webpack_public_path__ + "static/media/YCATlogo.c77b7d2e.jpg";